import store from '@/store'
import AppUtils from '@/utils/AppUtils'
import ApiUtils from '@/utils/api/ApiUtils'

// TODO: refactor
export const authorizationCheck = async (to, from, next) => {
  console.log('Navigating from:', from.name, 'to:', to.name)
  store.commit('App/SET_PREVIOUS_ROUTE_INFO', from)

  // Abort all running AJAX API request before navigate to other route to increase performance
  if (to.name !== from.name) ApiUtils.abortAll()

  // Initialize user data if it is not initialized
  try {
    if (store.getters['Auth/getInit'] === null) await store.dispatch('Auth/Auth_init')
  }
  catch (error) {
    console.warn('Auth/Auth_init Error')
  }

  const { debug } = to.meta
  if (debug) return next()

  if (store.getters['Auth/getUser'].id === undefined && to.name !== 'Login') { // User is not logged in, redirect to login
    window.vue.$dialog.notify.warning(window.vue.$t('auth.login.please_login'))
    return next({ name: 'Login', query: { next: to.fullPath } })
  }
  else if (store.getters['Auth/getUser'].id !== undefined && to.name === 'Login') { // User is logged in but going to login
    window.vue.$dialog.notify.warning(window.vue.$t('auth.login.already_login'))
    return next({ name: 'Home' })
  }

  // Authentication and Authorization Checks (combined into a single block)
  if (to.meta) {
    const { authenticated, roles, permissions, notLogged, debug } = to.meta
    // when user wants to access development only page in production mode
    if (debug && !AppUtils.isDebugMode()) return next({ name: 'Home' })

    // when user wants to access development only page in development mode
    if (debug && from.name !== 'AllCompsExample') {
      console.warn('Development only page!!\n if this page is production page, please remove `debug: true` in meta')
    }

    // when user is not logged in and going to a logged-in page
    if (authenticated && !AppUtils.isLoggedIn()) {
      window.vue.$dialog.notify.warning(window.vue.$t('auth.login.please_login'))
      return next({ name: 'Login', query: { next: to.fullPath } })
    }

    // when user is logged in and going to a not-logged-in page
    if (notLogged && AppUtils.isLoggedIn()) {
      window.vue.$dialog.notify.warning(window.vue.$t('auth.login.no_permission'))
      return next({ name: 'Home' })
    }

    // when user is open a page that requires roles or permissions that user does not have
    if ((roles || permissions) && !AppUtils.allowAccess(authenticated, roles, permissions)) {
      window.vue.$dialog.notify.warning(window.vue.$t('auth.login.no_permission'))
      return next({ name: 'Home' })
    }

    // when user is open a page that requires roles or permissions that user does not have
    if (store.getters['Auth/getFilteredAuthorityFunctionIDs'].length > 0 && !['Login', 'Home'].includes(to.name)) {
      if (!store.getters['Auth/getFilteredAuthorityFunctionIDs'].some((id) => to.name.includes(id))) {
        window.vue.$dialog.notify.warning(window.vue.$t('auth.login.no_permission'))
        return next({ name: 'Home' })
      }
    }
  }

  // If all checks pass, allow navigation
  next()
}
